module.exports = __webpack_public_path__ + "static/media/bg_3.9f07728a.jpg";